export enum Environments {
    Dev = 'Development',
    Sit = 'SIT',
    AuroraSit = 'AuroraSit',
    Uat = 'UAT',
    Prod = 'Production',
    Perf = 'Perf',
}
